import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  declarations: [AppFooterComponent, AppHeaderComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonModule,
    MenuModule
  ],
  exports: [AppFooterComponent, AppHeaderComponent],
  providers: [
    ConfirmationService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`${parentModule.constructor.name} has already bean loaded. Import this module in the AppModule only`);
    }
  }
}
